import { useLiveQuery } from 'dexie-react-hooks';
import { offlineDb } from './db';

interface PendingMutationsState {
  /** Mutations queued and waiting for a replay attempt. */
  pending: number;
  /** Mutations the server rejected with a non-retryable error. */
  failed: number;
}

/**
 * Live count of queued + failed mutations. Backed by Dexie's
 * useLiveQuery so the badge updates the moment a mutation is
 * enqueued or replayed — no polling.
 *
 * Returns 0/0 while the underlying query is still loading; the
 * indicator treats undefined-or-zero identically (hidden).
 */
export function usePendingMutations(): PendingMutationsState {
  const result = useLiveQuery(async () => {
    const [pending, failed] = await Promise.all([
      offlineDb.mutations
        .where('status')
        .anyOf('pending', 'replaying')
        .count(),
      offlineDb.mutations.where('status').equals('failed').count(),
    ]);
    return { pending, failed };
  });
  return result ?? { pending: 0, failed: 0 };
}
